import { Component, Inject, OnInit } from '@angular/core';
import { SubmittedFormFilterService } from '../submitted-form-filter/submitted-form-filter.service';
import * as _ from "lodash";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ScheduleService } from '../schedule/schedule.service';
import * as moment from 'moment';
import * as mtz from 'moment-timezone';

@Component({
  selector: 'app-multiple-scheduler',
  templateUrl: './multiple-scheduler.component.html',
  styleUrls: ['./multiple-scheduler.component.scss']
})
export class MultipleSchedulerComponent implements OnInit {

  users = [];
  selectedUsers = [];
  templates = [];
  selectedTemplates = [];
  time: any = {
    "hour": "",
    "minute": ""
  };
  hours;
  minutes = ["00", "30"]
  date;
  error;
  minDate = new Date();

  userDropdownSettings = {
    singleSelection: false,
    idField: "_id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableCheckAll: true,
    allowSearchFilter: true
  };

  formDropdownSettings = {
    singleSelection: true,
    idField: "_id",
    textField: "name",
    enableCheckAll: true,
    allowSearchFilter: true
  };

  
  
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MultipleSchedulerComponent>,
    private filterDeatailservice: SubmittedFormFilterService,
    private _scheduleService: ScheduleService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 

    this.date = new Date();
    this.time = {
      "hour": this.date.getHours(),
      "minute": this.date.getMinutes()
    }

    if(this.time.hour <= 9) {
      this.time.hour = `0${this.time.hour}`
    } else {
      this.time.hour = `${this.time.hour}`;
    }

    if (this.time.minute <= 29) {
      this.time.minute = "00"
    } else {
      this.time.minute = "30"
    }

    this.hours = Array.from(Array(24).keys())

    this.hours = _.map(this.hours, (hour) => {
      if(hour <= 9) {
        hour = `0${hour}`
      } else {
        hour = `${hour}`
      }
      return hour;
    })

  }

  ngOnInit() {
    this.templates = this.data['templates']
    this.users = this.data['users']
  }


  onSchedule() {

    
    if(_.isEmpty(this.selectedTemplates) || _.isEmpty(this.selectedUsers)) {
      this.error = "Please select Template and Users to schedule the inspection";
      return;
    }
    
    this.time.hour = parseInt(this.time.hour);
    this.time.minute = parseInt(this.time.minute);
    
    this.date.setHours(this.time.hour);
    this.date.setMinutes(this.time.minute);
    this.date.setSeconds(0);

    
    const component = this;
    
    let promises = [];
    async function schedule(scheduleObj) {
        return new Promise(async (resolve, reject) => {
          try {
            component._scheduleService.createSchedule(scheduleObj).toPromise()
              .then((result) => {
                resolve(result)
              })
              .catch((error) => {
                reject(error);
              })
          } catch (error) {
            reject(error);
            console.log("errror", error)
          }
        })
    }

    for(let template of this.selectedTemplates) {
      const templateId = template['_id'];
      const templateName = template['name'];

      let teamTimezone = localStorage.getItem("timezone");
      for(let user of this.selectedUsers) {
        user = _.find(this.users, {
          _id: user._id
        })
        let scheduleObj = {
          userId: user._id,
          userName: user.name,
          userRole: user.role,
          templateId: templateId,
          templateName: templateName,
          scheduleAt: this.date + moment().format('Z'),
          status: 0
        }
        if(!_.isEmpty(teamTimezone)) {
          let selectedMoment = mtz.tz(this.date, "YYYY-MM-DD",teamTimezone);
          selectedMoment.set({ hour: this.time.hour, minute: this.time.minute });
          scheduleObj.scheduleAt = selectedMoment.format();
        }
        promises.push(schedule(scheduleObj));
      }
    }

    Promise.all(promises)
      .then((result) => {
        console.log("Final result", result)
        this.dialogRef.close({
          continueClose: true
        })
        this.selectedUsers = [];
        this.selectedTemplates = [];
      })
      .catch(() => {
        console.log("faied to save data");
        this.error = "Server side error occured can't schedule inspections"
      })
  }

  onCancel() {
    this.dialogRef.close();
  }

  onElementChange() {
    this.error = ""
  }

}



// WEBPACK FOOTER //
// ./src/app/multiple-scheduler/multiple-scheduler.component.ts